// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planCard_planCardWrapper__DPkp9 {
  position: relative;
  border-radius: 16px;
  padding: 1px;
  background: linear-gradient(90deg, #d5982f 0%, #8a2c89 100%);
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 100%;
  align-self: stretch;
}

.planCard_planCardWrapper__DPkp9:hover {
  opacity: 0.9;
}

.planCard_planCard__h69Oq {
  border-radius: 16px;
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  box-sizing: border-box;
  background: linear-gradient(109deg, #3C2929 0%, #161B20 100%);
  border: 1px solid #8A2C89;
  align-self: stretch;
}

.planCard_planHeader__39eou {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 6px;
}

.planCard_priceContainer__Ti4\\+U {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
}

.planCard_actualPrice__61WTt {
  font-family: 'Noto Sans', sans-serif;
  white-space: nowrap;
}

.planCard_strikePrice__5ab-o {
  font-family: 'Noto Sans', sans-serif;
  white-space: nowrap;
}

.planCard_perDayBadge__RY1OR {
  background: #0d0e11;
  border-radius: 4px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.planCard_perDayText__533cy {
  font-family: 'Noto Sans', sans-serif;
  white-space: nowrap;
}

.planCard_planFooter__CNbZq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.planCard_validityText__jbE9h {
  font-family: 'Noto Sans', sans-serif;
}

.planCard_tag__SNFYK {
  font-family: 'Noto Sans', sans-serif;
  font-size: 10px;
  font-weight: 500;
  color: #ffffff;
  background: linear-gradient(90deg, #D5982F 0%, #FDF59A 50%, #D5982F 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/PlanCard/planCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,4DAA4D;EAC5D,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yEAAyE;EACzE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".planCardWrapper {\n  position: relative;\n  border-radius: 16px;\n  padding: 1px;\n  background: linear-gradient(90deg, #d5982f 0%, #8a2c89 100%);\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  width: 100%;\n  align-self: stretch;\n}\n\n.planCardWrapper:hover {\n  opacity: 0.9;\n}\n\n.planCard {\n  border-radius: 16px;\n  padding: 16px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  box-sizing: border-box;\n  background: linear-gradient(109deg, #3C2929 0%, #161B20 100%);\n  border: 1px solid #8A2C89;\n  align-self: stretch;\n}\n\n.planHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 6px;\n}\n\n.priceContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.actualPrice {\n  font-family: 'Noto Sans', sans-serif;\n  white-space: nowrap;\n}\n\n.strikePrice {\n  font-family: 'Noto Sans', sans-serif;\n  white-space: nowrap;\n}\n\n.perDayBadge {\n  background: #0d0e11;\n  border-radius: 4px;\n  padding: 4px 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.perDayText {\n  font-family: 'Noto Sans', sans-serif;\n  white-space: nowrap;\n}\n\n.planFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.validityText {\n  font-family: 'Noto Sans', sans-serif;\n}\n\n.tag {\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  background: linear-gradient(90deg, #D5982F 0%, #FDF59A 50%, #D5982F 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  padding: 2px 6px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCardWrapper": `planCard_planCardWrapper__DPkp9`,
	"planCard": `planCard_planCard__h69Oq`,
	"planHeader": `planCard_planHeader__39eou`,
	"priceContainer": `planCard_priceContainer__Ti4+U`,
	"actualPrice": `planCard_actualPrice__61WTt`,
	"strikePrice": `planCard_strikePrice__5ab-o`,
	"perDayBadge": `planCard_perDayBadge__RY1OR`,
	"perDayText": `planCard_perDayText__533cy`,
	"planFooter": `planCard_planFooter__CNbZq`,
	"validityText": `planCard_validityText__jbE9h`,
	"tag": `planCard_tag__SNFYK`
};
export default ___CSS_LOADER_EXPORT___;
